import * as ReactService from "@intech/react-service";
import { FileUploadEntidade } from "../entidades/FileUploadEntidade";
import { WebRecadPublicoAlvoEntidade } from "../entidades/WebRecadPublicoAlvoEntidade";
import { WebRecadParticipanteDadosEntidade } from "../entidades/WebRecadParticipanteDadosEntidade";
import { DependenteEntidade } from "../entidades/DependenteEntidade";
import { ContribuicaoIndividualEntidade } from "../entidades/ContribuicaoIndividualEntidade";
import { EstadoCivilEntidade } from "../entidades/EstadoCivilEntidade";
import { UFEntidade } from "../entidades/UFEntidade";
import { PaisEntidade } from "../entidades/PaisEntidade";
import { SexoEntidade } from "../entidades/SexoEntidade";
import { WebRecadDadosConclusaoEntidade } from "../entidades/WebRecadDadosConclusaoEntidade";
import { BancoAgEntidade } from "../entidades";

class Recadastramento extends ReactService.BaseService {
  constructor() {
    super("Recadastramento");
  }

  Upload = (Arquivo: FileUploadEntidade) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `Upload`, Arquivo);

  BuscarPorCpf = () =>
    this.CreateRequest<WebRecadPublicoAlvoEntidade[]>(ReactService.RequestType.GET, `BuscarPorCpf`);

  BuscarDadosPorCpf = (oid: number) =>
    this.CreateRequest<WebRecadParticipanteDadosEntidade>(ReactService.RequestType.GET, `BuscarDadosPorCpf/${oid}`);

  BuscarDependentes = () =>
    this.CreateRequest<DependenteEntidade[]>(ReactService.RequestType.GET, `BuscarDependentes`);

  BuscarBeneficiarios = () =>
    this.CreateRequest<DependenteEntidade[]>(ReactService.RequestType.GET, `BuscarBeneficiarios`);

  BuscarContribPensao = () =>
    this.CreateRequest<ContribuicaoIndividualEntidade[]>(ReactService.RequestType.GET, `BuscarContribPensao`);

  ValidarEmail = (email: string) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `ValidarEmail/${email}`);

  ValidarCpf = (cpf: string) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `ValidarCpf/${cpf}`);

  ValidarDataEmissao = (dataEmissao: string) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `ValidarDataEmissao/${dataEmissao}`);

  BuscarListaEstadoCivil = () =>
    this.CreateRequest<EstadoCivilEntidade[]>(ReactService.RequestType.GET, `BuscarListaEstadoCivil`);

  BuscarEstadoCivil = (CdEstadoCivil: string) =>
    this.CreateRequest<EstadoCivilEntidade>(ReactService.RequestType.GET, `BuscarEstadoCivil/${CdEstadoCivil}`);

  BuscarListaUF = () =>
    this.CreateRequest<UFEntidade[]>(ReactService.RequestType.GET, `BuscarListaUF`);

  BuscarUF = (CdUF: string) =>
    this.CreateRequest<UFEntidade>(ReactService.RequestType.GET, `BuscarUF/${CdUF}`);

  BuscarListaPais = () =>
    this.CreateRequest<PaisEntidade[]>(ReactService.RequestType.GET, `BuscarListaPais`);

  BuscarPais = (CdPais: string) =>
    this.CreateRequest<PaisEntidade>(ReactService.RequestType.GET, `BuscarPais/${CdPais}`);

  BuscarListaSexo = () =>
    this.CreateRequest<SexoEntidade[]>(ReactService.RequestType.GET, `BuscarListaSexo`);

  BuscarListaBanco = () =>
    this.CreateRequest<BancoAgEntidade[]>(ReactService.RequestType.GET, `BuscarListaBanco`);

  Concluir = (Dados: WebRecadDadosConclusaoEntidade) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `Concluir`, Dados);

  GerarToken = (metodoEnvio: string, alvoEnvio: string) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `GerarToken/${metodoEnvio}/${alvoEnvio}`);

}

export const RecadastramentoService = new Recadastramento();
